import React from "react";

const HeaderEndElement = ({desktopEndContainer}: {desktopEndContainer?: React.ReactElement}) => {
  if (desktopEndContainer) {
    return <>{desktopEndContainer}</>;
  }
  return null;
}

export { HeaderEndElement };
